module.exports = __webpack_public_path__ + "img/R8806-IB.1a95e5d7.jpg";